import { render, staticRenderFns } from "./approvalRules.vue?vue&type=template&id=d6f4bb3c&scoped=true"
import script from "./approvalRules.vue?vue&type=script&lang=js"
export * from "./approvalRules.vue?vue&type=script&lang=js"
import style0 from "./approvalRules.vue?vue&type=style&index=0&id=d6f4bb3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f4bb3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6f4bb3c')) {
      api.createRecord('d6f4bb3c', component.options)
    } else {
      api.reload('d6f4bb3c', component.options)
    }
    module.hot.accept("./approvalRules.vue?vue&type=template&id=d6f4bb3c&scoped=true", function () {
      api.rerender('d6f4bb3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/ruleSettings/components/approvalRules.vue"
export default component.exports